import { pageIdInfos } from '@/Providers'

export const PortraitOnlyPagePath = new Set<string>([
  pageIdInfos.move_log.url,
  pageIdInfos.move_log_insight.url,
])
